import type { ProductKeys } from '../../constants/product-keys';
import { type FireAnalyticsEvent } from '../../types';

export const onRecommendationsServed = ({
	searchSessionId,
	visibleProductsToAuth,
	recommended3pApps,
}: {
	searchSessionId?: string;
	visibleProductsToAuth: (ProductKeys | undefined)[];
	recommended3pApps: string[];
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationServed',
	attributes: {
		additionalAttributes: {
			searchSessionId,
			visibleProductsToAuth,
			recommended3pApps,
		},
	},
});
